export const DepositMessages = {
    UnavailableAccountFromCash: {
        key: 'UnavailableAccountFromCash',
        message: 'Account From cash is unavailable.'
    },
    AccountFromNotEnoughMoney: {
        key: 'AccountFromNotEnoughMoney',
        message: 'Account From hasn\'t enough money.'
    },
    GetAccountFailed: {
        key: 'GetAccountFailed',
        message: 'Account information is currently unavailable'
    },
    GetClientFailed: {
        key: 'GetClientFailed',
        message: 'Can\'t find details about the account owner.'
    },
    RegisterBankDepositFailed: {
        key: 'RegisterBankDepositFailed',
        message: 'Bank deposit failed.'
    },
    RegisterBankDepositSucceed: {
        key: 'RegisterBankDepositSucceed',
        message: 'Bank deposit is successfully created.'
    },
    RegisterInternalDepositFailed: {
        key: 'RegisterInternalDepositFailed',
        message: 'Internal deposit failed.'
    },
    RegisterInternalDepositSucceed: {
        key: 'RegisterInternalDepositSucceed',
        message: 'Internal deposit is successfully created.'
    },
    CanFindCorrectPaymentMethod: {
        key: 'CanFindCorrectPaymentMethod',
        message: 'Deposit method mismatch.'
    },
    GetDefaultVendorBankAccountFailed: {
        key: 'GetDefaultVendorBankAccountFailed',
        message: 'Can\'t get default recipient bank details.'
    },
    DefaultVendorBankAccountNotFound: {
        key: 'DefaultVendorBankAccountNotFound',
        message: 'Can\'t find default recipient bank details.'
    }
};
